import "../../../src/main.css";
import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import Filter from "assets/svgs/filter/Filter";
import { Select } from "antd";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function OffCanvas({ name, ...props }) {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [assignedTo, setAssignedTo] = useState(
    searchParams.get("assignedTo") ? searchParams.get("assignedTo") : ""
  );
  const [isFinished, setIsFinished] = useState(
    searchParams.get("isFinished") ? searchParams.get("isFinished") : ""
  );
  const [bsd, setBsd] = useState(
    searchParams.get("bookingStartDate")
      ? searchParams.get("bookingStartDate")
      : ""
  );
  const [bed, setBed] = useState(
    searchParams.get("bookingEndDate") ? searchParams.get("bookingEndDate") : ""
  );
  const [ssd, setSsd] = useState(
    searchParams.get("slotStartDate") ? searchParams.get("slotStartDate") : ""
  );
  const [sed, setSed] = useState(
    searchParams.get("slotEndDate") ? searchParams.get("slotEndDate") : ""
  );
  const [repLevel, setRepLevel] = useState(
    searchParams.get("repLevel") ? searchParams.get("repLevel") : ""
  );
  const [category, setCategory] = useState(
    searchParams.get("category") ? searchParams.get("category") : ""
  );
  const { salesReps } = props;


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleSubmit = (e) => {
    e.preventDefault();
    const queryParamsArray = [
      bsd && `bookingStartDate=${encodeURIComponent(bsd)}`,
      bed && `bookingEndDate=${encodeURIComponent(bed)}`,
      ssd && `slotStartDate=${encodeURIComponent(ssd)}`,
      sed && `slotEndDate=${encodeURIComponent(sed)}`,
      assignedTo && `assignedTo=${assignedTo}`,
      isFinished && `isFinished=${isFinished}`,
      repLevel && `repLevel=${repLevel}`,
      category && `category=${category}`,
    ];
    const queryParams = queryParamsArray.join("&");
    navigate(`/case-management/slotBooking?${queryParams}&pageNumber=1`);
  };

  const handleClear = async () => {
    setBsd(null);
    setBed(null);
    setSsd(null);
    setSed(null);
    setIsFinished(null);
    setAssignedTo(null);
    setRepLevel(null);
    setCategory(null);
    navigate(`/case-management/slotBooking?pageNumber=1`);
  };

  return (
    <>
      <div
        variant="primary"
        onClick={handleShow}
        className="me-2 cursor-pointer"
      >
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
              <div className="fs-1">more filter options</div>
            </Tooltip>
          }
        >
          <Filter />
        </OverlayTrigger>
      </div>
      <Offcanvas show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h1>Traya</h1>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="d-flex gap-2">
            <div className="order-filter d-flex flex-column gap-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label
                    htmlFor="booking_start_date_input"
                    className="form-label"
                  >
                    Booking Start Date
                  </label>
                  <ReactDatePicker
                    selected={bsd ? new Date(bsd) : null}
                    onChange={(date) => {
                      setBsd(date);
                    }}
                    className="form-control"
                    placeholderText="DD-MM-YYYY h:mm aa"
                    timeIntervals={5}
                    dateFormat="dd-MM-yyyy h:mm aa"
                    showTimeSelect
                    fixedHeight
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="booking_end_date_input"
                    className="form-label"
                  >
                    Booking End Date
                  </label>

                  <ReactDatePicker
                    selected={bed ? new Date(bed) : null}
                    onChange={(date) => setBed(date)}
                    className="form-control"
                    placeholderText="DD-MM-YYYY h:mm aa"
                    timeIntervals={5}
                    dateFormat="dd-MM-yyyy h:mm aa"
                    showTimeSelect
                    fixedHeight
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="slot_start_date_input" className="form-label">
                    Slot Start Date
                  </label>

                  <ReactDatePicker
                    selected={ssd ? new Date(ssd) : null}
                    onChange={(date) => setSsd(date)}
                    className="form-control"
                    placeholderText="DD-MM-YYYY h:mm aa"
                    timeIntervals={5}
                    dateFormat="dd-MM-yyyy h:mm aa"
                    showTimeSelect
                    fixedHeight
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="slot_end_date_input" className="form-label">
                    Slot End Date
                  </label>

                  <ReactDatePicker
                    selected={sed ? new Date(sed) : null}
                    onChange={(date) => setSed(date)}
                    className="form-control"
                    placeholderText="DD-MM-YYYY h:mm aa"
                    timeIntervals={5}
                    dateFormat="dd-MM-yyyy h:mm aa"
                    showTimeSelect
                    fixedHeight
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="is_finished_input" className="form-label">
                    Is Finished
                  </label>
                  <Select
                    allowClear
                    dropdownStyle={{ minWidth: "10rem" }}
                    id="is_finished_input"
                    onChange={(e) =>
                      e ? setIsFinished(e) : setIsFinished(null)
                    }
                    placeholder="Is Finished"
                    className="w-100"
                    value={isFinished}
                  >
                    {isFinishedOptions.map((option) => (
                      <option value={option.value} key={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="mb-3">
                  <label htmlFor="assign_to_input" className="form-label">
                    Assigned To
                  </label>
                  <Select
                    allowClear
                    dropdownStyle={{ minWidth: "12rem" }}
                    id="assign_to_input"
                    onChange={(e) =>
                      e ? setAssignedTo(e) : setAssignedTo(null)
                    }
                    placeholder="Assigned To"
                    className="w-100"
                    value={assignedTo}
                  >
                    {salesReps?.userRole?.map((users) => (
                      <option value={users.user.id} key={users.user.id}>
                        {users.user.first_name}
                      </option>
                    ))}
                  </Select>
                </div>

                <div className="mb-3">
                  <label htmlFor="repLevel" className="form-label">
                    Level
                  </label>
                  <Select
                    allowClear
                    onChange={(e) =>
                      e ? setRepLevel(e) : setRepLevel(undefined)
                    }
                    placeholder="Level"
                    className="w-100"
                    value={repLevel}
                  >
                    {levelOptions.map((option) => (
                      <option value={option.value} key={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Select>
                </div>

                <div className="mb-3">
                  <label htmlFor="category" className="form-label">
                    Form Type
                  </label>
                  <Select
                    allowClear
                    onChange={(e) =>
                      e ? setCategory(e) : setCategory(undefined)
                    }
                    placeholder="Form Type"
                    className=" w-100"
                    value={category}
                  >
                    {categoryOptions.map((option) => (
                      <option value={option.value} key={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Select>
                </div>

                <div className="d-flex gap-5 mt-4">
                  <button
                    type="submit"
                    id="filter_apply_btn"
                    className="btn btn-primary w-50"
                  >
                    Apply
                  </button>

                  <button
                    type="button"
                    id="filter_clear_btn"
                    className="btn btn-primary w-50"
                    onClick={() => handleClear()}
                  >
                    Clear
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function SlotBookingCanvas({ salesReps }) {
  return (
    <>
      <OffCanvas
        key={6}
        placement={"end"}
        name={"Filter & Download"}
        salesReps={salesReps}
      />
    </>
  );
}

export default SlotBookingCanvas;

const isFinishedOptions = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];
const levelOptions = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
];
const categoryOptions = [
  { label: "Hair", value: "hair" },
  { label: "Cholesterol", value: "cholesterol" },
];
